export default "__VITE_ASSET__CBt7FAmR__"